import {Injectable} from "@angular/core";
import {StorageKeysEnum} from "../../enums/storage-key.enum";

@Injectable({providedIn: "root"})
export class PermissionMancomunadosPaymentsService {

  constructor() {
  }


  hasFacultadesPermission(contractId: any): boolean {
    const mancomunadosContractsString = sessionStorage.getItem(StorageKeysEnum.CONTRACTS_FACMAN);
    const mancomunadosContracts = mancomunadosContractsString ? mancomunadosContractsString.split(',') : [];
    return mancomunadosContracts.includes(contractId);
  }

}
